/**
 * Naming constants for product-facing TestDefinition terms.
 */

export const TEST_DEFINITIONS = 'Test definitions';
